import { render } from "./AnimatedButton.vue?vue&type=template&id=e8cb4296"
import script from "./AnimatedButton.vue?vue&type=script&lang=js"
export * from "./AnimatedButton.vue?vue&type=script&lang=js"

import "./AnimatedButton.vue?vue&type=style&index=0&id=e8cb4296&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__